<style >
  .ivu-switch-checked {
      border-color: #6366f1;
      background-color: #13ce66;
  }
</style>

<template>
    <div>
        <Login v-show="!isLoggedIn" @setIsLoggedIn="setIsLoggedIn" />
        <div class="layout" v-show="isLoggedIn">
            <!-- TOP BAR -->
            <div class="layout-ceiling">
              <!-- LEFT -->
              <div class="ceiling-left">
                <div class="app-brand">
                  <!-- LOGO -->
                  <div class="logo-wrap">
                    <img
                      src="/static/login-logo-r1.png"
                      alt="Logo"
                      class="app-logo"
                    />
                  </div>


                  <!-- APP INFO -->
                  <div class="app-info">
                    <div class="app-tags">
                       <span class="tag tag-name">
                        {{ appName }}
                      </span>
                      <span class="tag tag-version">
                        v{{ appVersion }}
                      </span>

                      <span class="tag tag-build">
                        {{ checkAppJSTag() }}
                      </span>

                      <span v-if="isDev" class="tag tag-dev">
                        DEV
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- RIGHT -->
              <div class="ceiling-right">
                <div class="tab-switch">
                  <span>Tab Mode</span>
                  <i-switch
                    v-model="useTab"
                    size="large"
                    @on-change="onTabChange"
                    open-color="#22c55e"
                    close-color="#ef4444"
                  >
                    <span slot="open">On</span>
                    <span slot="close">Off</span>
                  </i-switch>
                </div>

                <div class="user-action">
                  <div class="user-box">
                    <Icon type="ios-person-circle-outline" size="22" />
                    <div class="user-text">
                      <div class="username">{{ user.username }}</div>
                      <div class="role">{{ user.role }}</div>
                    </div>
                  </div>

                  <Button
                    class="logout-btn"
                    type="error"
                    size="small"
                    @click="logout"
                  >
                    <Icon type="log-out" />
                  </Button>
                </div>
              </div>
            </div>
            <div class="layout-content">
                <Row>
                    <Col span="4">
                    <Menu
                      active-name="2-1"
                      width="auto"
                      class="sidebar-menu"
                    >


                        <!-- <Submenu name="1"
                                v-show="canAccessMenu('suratjalan')">
                                <template slot="title">
                                    <Icon type="document-text" :size="iconSize"></Icon>
                                    Surat Jalan
                                </template>
                                <router-link to="/invoice/receive"><Menu-item name="1-1">Terima</Menu-item></router-link>
                                <router-link to="/invoice/receiveHistory"><Menu-item name="1-2">Histori</Menu-item></router-link>
                            </Submenu>                         -->

                        <!--
                            <Submenu name="1"
                                v-show="canAccessMenu('dashboard')">
                                <template slot="title">
                                    <Icon type="document-text" :size="iconSize"></Icon>
                                    Dashboard
                                </template>
                                <router-link to="/dashboard/invoices"><Menu-item name="1-1">Invoices</Menu-item></router-link>
                            </Submenu>
    -->

                        <Submenu name="2" v-show="canAccessMenu('kontra')">
                            <template slot="title">
                                <Icon type="ios-filing-outline" :size="iconSize"></Icon>
                                Kontra
                            </template>
                            <router-link to="/kontra/create"><Menu-item name="2-1">Buat</Menu-item></router-link>
                            <router-link to="/kontra/print"><Menu-item name="2-2">Cetak</Menu-item></router-link>
                            <router-link to="/kontra/reprint"><Menu-item name="2-3">Cetak
                                    Ulang</Menu-item></router-link>
                        </Submenu>

                        <Submenu name="3" v-show="canAccessMenu('piutang')">
                            <template slot="title">
                                <Icon type="ios-paper-outline" :size="iconSize"></Icon>
                                Piutang
                            </template>

                            <router-link to="/invoice/invoiceUnSettled"><Menu-item name="3-1">Jatuh
                                    Tempo</Menu-item></router-link>
                            <router-link to="/receivable/list/cut-off"><Menu-item name="3-2">Kartu
                                    Piutang</Menu-item></router-link>
                            <router-link to="/receivable/list"><Menu-item name="3-3">Kartu Piutang
                                    History</Menu-item></router-link>
                            <router-link to="/receivable/delete" v-show="canAccessMenu('pembayaran-delete')"><Menu-item
                                    name="3-4">Hapus Piutang</Menu-item></router-link>
                            <router-link to="/invoice/delete" v-show="canAccessMenu('pembayaran-delete')"><Menu-item
                                    name="3-5">Hapus Invoice</Menu-item></router-link>
                            <router-link to="/invoice/failedInvoicing"><Menu-item name="3-6">Failed
                                    Invoicing</Menu-item></router-link>
                            <router-link to="/receivable/receivableAddList"><Menu-item name="3-7">List Piutang
                                    Manual</Menu-item></router-link>
                            <router-link to="/receivable/hotList"><Menu-item name="3-8">Summary Kartu
                                    Piutang</Menu-item></router-link>
                            <router-link to="/receivable/list-detail"><Menu-item name="3-9">Kartu Piutang
                                    Detail</Menu-item></router-link>
                        </Submenu>

                        <Submenu name="4" v-show="canAccessMenu('pembayaran')">
                            <template slot="title">
                                <Icon type="social-usd-outline" :size="iconSize"></Icon>
                                Pembayaran
                            </template>

                            <router-link to="/receivable/pendingFunds"><Menu-item
                                    name="4-1">Tambah</Menu-item></router-link>

                            <router-link :to="`/payment/paymentPending/list-data/search/${ Date.now() }`"><Menu-item name="4-2">List
                                    Data</Menu-item></router-link>

                            <router-link to="/payment/add" v-show="canAccessMenu('pembayaran-tambah')"><Menu-item
                                    name="4-3">Penyesuaian</Menu-item></router-link>

                            <!-- <router-link to="/payment/adjustment" v-show="canAccessMenu('pembayaran-tambah')"><Menu-item
                                    name="4-3">Penyesuaian Baru</Menu-item></router-link> -->

                            <router-link to="/payment/list" v-show="canAccessMenu('pembayaran-history')"><Menu-item
                                    name="4-4">Histori</Menu-item></router-link>

                            <router-link to="/payment/discount-list"
                                v-show="canAccessMenu('potongan-history')"><Menu-item name="4-5">Histori
                                    Potongan</Menu-item></router-link>

                            <router-link to="/payment/delete" v-show="canAccessMenu('pembayaran-delete')"><Menu-item
                                    name="4-6">Hapus</Menu-item></router-link>

                            <router-link to="/payment/history/delete"
                                v-show="canAccessMenu('pembayaran-history-delete')"><Menu-item name="4-7">Histori
                                    Hapus</Menu-item></router-link>

                            <router-link to="/payment/download"><Menu-item name="4-8">Download</Menu-item></router-link>

                            <!-- <router-link to="/payment/paymentPending/list"
                                    v-show="canAccessMenu('pembayaran-pending-list')">
                                    <Menu-item name="4-4">Pending</Menu-item></router-link> -->
                        </Submenu>

                        <Submenu name="5" v-show="canAccessMenu('mutasi-nota-transaksi')">
                            <template slot="title">
                                <Icon type="social-usd-outline" :size="iconSize"></Icon>
                                Nota Transaksi
                            </template>
                            <!-- <router-link to="/mutasi/create" v-show="canAccessMenu('mutasi-nota-transaksi')"><Menu-item name="5-1">Tambah</Menu-item></router-link> -->
                            <router-link to="/mutasi/list" v-show="canAccessMenu('mutasi-nota-transaksi')"><Menu-item
                                    name="5-1">Mutasi</Menu-item></router-link>
                            <router-link to="/mutasi/list/giro" v-show="canAccessMenu('mutasi-nota-transaksi')"><Menu-item
                                    name="5-2">Giro</Menu-item></router-link>
                            <router-link to="/mutasi/list/adjustment"
                                v-show="canAccessMenu('mutasi-nota-transaksi')"><Menu-item
                                    name="5-3">Penyesuaian</Menu-item></router-link>
                            <router-link to="/fix-note"
                                v-show="canAccessMenu('mutasi-nota-transaksi')"><Menu-item
                                    name="5-4">Penyesuaian Nomor Nota Transaksi</Menu-item></router-link>
                            <!-- <router-link to="/payment/paymentPending/list"
                                    v-show="canAccessMenu('pembayaran-pending-list')">
                                    <Menu-item name="4-4">Pending</Menu-item></router-link> -->
                        </Submenu>

                        <!-- <Submenu name="5"
                                v-show="canAccessMenu('deposit')">
                                <template slot="title">
                                <Icon type="ios-paper-outline" :size="iconSize"></Icon>
                                    Deposit
                                </template>
                                <router-link to="/deposit/add" v-show="canAccessMenu('deposit-add')"><Menu-item name="5-1">Tambah</Menu-item></router-link>
                            </Submenu> -->

                        <!-- <Submenu name="6"
                                v-show="canAccessMenu('pending')">
                                <template slot="title">
                                <Icon type="ios-book-outline" :size="iconSize"></Icon>
                                    Pending
                                </template>
                                <router-link to="/receivable/pendingFunds"><Menu-item name="6-1">Tambah</Menu-item></router-link>
                                <router-link to="/payment/paymentPending/list"><Menu-item name="6-2">List</Menu-item></router-link>
                                <router-link to="/payment/paymentPending/list-data"><Menu-item name="6-3">List Data</Menu-item></router-link>
                            </Submenu> -->

                        <Submenu name="7" v-show="canAccessMenu('claim')">
                            <template slot="title">
                                <Icon type="ios-checkmark-outline" :size="iconSize"></Icon>
                                Klaim
                            </template>
                            <router-link to="/claim/add"><Menu-item name="7-1">Tambah</Menu-item></router-link>
                            <router-link to="/claim/list"><Menu-item name="7-2">List</Menu-item></router-link>
                            <router-link to="/claim/download"><Menu-item name="7-3">Download</Menu-item></router-link>
                            <router-link to="/claim/transaction-note"><Menu-item name="7-4">Nota
                                    Transaksi</Menu-item></router-link>
                        </Submenu>
                        <Submenu name="8" v-show="canAccessMenu('giro')">
                            <template slot="title">
                                <Icon type="ios-copy-outline" :size="iconSize" style="margin-right:13px"></Icon>
                                Giro
                            </template>
                            <!-- <router-link to="/giro"><Menu-item name="8-1">Tambah</Menu-item></router-link> -->
                            <router-link to="/giro/list"><Menu-item name="8-1">List</Menu-item></router-link>
                            <router-link to="/giro/pending"><Menu-item name="8-2">Pending</Menu-item></router-link>
                            <router-link to="/giro/calendar"><Menu-item name="8-3">Kalender</Menu-item></router-link>
                            <router-link to="/giro/dueDate"><Menu-item name="8-4">Jatuh Tempo</Menu-item></router-link>
                            <router-link to="/giro/cancelled-history"><Menu-item name="8-5">Histori
                                    Pembatalan</Menu-item></router-link>
                            <router-link to="/giro/transaction-note"><Menu-item name="8-6">Nota
                                    Transaksi</Menu-item></router-link>

                        </Submenu>

                        <!-- <router-link to="/claim">
                                <Menu-item name="6">
                                    <Icon type="ios-checkmark-outline" :size="iconSize" style="margin-right:11px"></Icon>Klaim
                                </Menu-item>
                            </router-link> -->

                        <Submenu name="9" v-show="canAccessMenu('deposit')">
                            <template slot="title">
                                <Icon type="ios-checkmark-outline" :size="iconSize"></Icon>
                                Deposit
                            </template>
                            <!-- <router-link to="/deposit/create"><Menu-item name="9-1">Tambah</Menu-item></router-link> -->
                            <router-link to="/deposit-adjustment"><Menu-item name="9-1">Penyesuaian & Mutasi</Menu-item></router-link>
                            <!-- <router-link to="/deposit-mutation"><Menu-item name="9-2">Mutasi</Menu-item></router-link> -->
                            <router-link to="/deposit/withdrawal-history"><Menu-item name="9-3">Histori
                                    Penarikan</Menu-item></router-link>
                        </Submenu>

                        <Submenu name="10">
                            <template slot="title">
                                <Icon type="ios-list-outline" :size="iconSize"></Icon>
                                Master
                            </template>
                            <span v-show="canAccessMenu('master')">
                                <router-link to="/master/user">
                                    <Menu-item name="10-1">User</Menu-item>
                                </router-link>
                                <router-link to="/master/itemDept">
                                    <Menu-item name="10-2">Item Dept</Menu-item>
                                </router-link>
                                <router-link to="/master/bankAccount">
                                    <Menu-item name="10-3">Bank Account</Menu-item>
                                </router-link>
                                <router-link to="/master/bankAccountGroup">
                                    <Menu-item name="10-5">Bank Account Group</Menu-item>
                                </router-link>
                                <router-link to="/master/Division">
                                    <Menu-item name="10-6">Division</Menu-item>
                                </router-link>
                            </span>
                            <span v-show="canAccessMenu('master.marking-top')">
                                <router-link to="/master/marking-top">
                                    <Menu-item name="10-7">Marking TOP</Menu-item>
                                </router-link>
                            </span>
                            <span v-show="canAccessMenu('master.marking-group')">
                                <router-link to="/master/markingGroup">
                                    <Menu-item name="10-8">Marking Group</Menu-item>
                                </router-link>
                            </span>
                            <router-link to="/master/coa">
                                <Menu-item name="9-5">Chart of Account (COA)</Menu-item>
                            </router-link>

                            <!--
                                <router-link to="/master/role">
                                    <Menu-item name="5-2">Role</Menu-item>
                                </router-link>
                                -->
                        </Submenu>

                        <Submenu name="11" v-show="canAccessMenu('sms')">>
                            <template slot="title">
                                <Icon type="ios-email-outline" :size="iconSize"></Icon>
                                SMS
                            </template>
                            <!--
                                <router-link to="/sms/send">
                                        <Menu-item name="6-1">Send</Menu-item>
                                </router-link>
                                -->
                            <router-link to="/sms/log">
                                <Menu-item name="10-2">Log</Menu-item>
                            </router-link>
                        </Submenu>

                        <Submenu name="12" v-show="canAccessMenu('administrator')">
                            <template slot="title">
                                <Icon type="printer" :size="iconSize"></Icon>
                                Administrator
                            </template>
                            <router-link to="/administrator/kontra/isprint"><Menu-item name="12-1">Kontra Print
                                    Status</Menu-item></router-link>
                            <router-link to="/administrator/receivable/delete"><Menu-item name="12-2">Hapus
                                    Piutang</Menu-item></router-link>

                        </Submenu>

                        <Submenu name="13" v-show="canAccessMenu('suratjalan')">
                            <template slot="title">
                                <Icon type="ios-printer-outline" :size="iconSize"></Icon>
                                Surat Jalan
                            </template>
                            <router-link to="/surat/suratjalan">
                                <Menu-item name="13-1">Surat Jalan</Menu-item>
                            </router-link>
                            <router-link to="/surat/suratjalanbelumprint">
                                <Menu-item name="13-2">Surat Jalan Belum Di Print</Menu-item>
                            </router-link>
                        </Submenu>

                        <router-link to="/settings" class="menu-parents">
                            <Menu-item name="14">
                                <Icon type="ios-gear-outline" :size="iconSize" style="margin-right:13px"></Icon>Setting
                            </Menu-item>
                        </router-link>

                        <Submenu name="15" v-show="canAccessMenu('administrator')">
                            <template slot="title">
                                <Icon type="ios-folder-outline" :size="iconSize"></Icon>
                                Logs
                            </template>
                            <router-link to="/logs/erp/journal-pooling"><Menu-item name="15-1">ERP Journal
                                    Pooling</Menu-item></router-link>
                        </Submenu>

                        <!-- <Submenu name="16" v-show="canAccessMenu('administrator')">
                          <template slot="title">
                              <Icon type="arrow-graph-up-right" :size="iconSize"></Icon>
                              Omset
                          </template>

                          <router-link to="/omset/add">
                              <Menu-item name="16-1"> Tambah </Menu-item>
                          </router-link>
                          <router-link to="/omset/list">
                              <Menu-item name="16-2"> List </Menu-item>
                          </router-link>
                        </Submenu> -->
                        <router-link to="/omset/list" class="menu-parents">
                            <Menu-item name="16">
                                <Icon type="arrow-graph-up-right" :size="iconSize"></Icon>
                                Omset
                            </Menu-item>
                        </router-link>

                    </Menu>
                    </Col>

                    <Col span="20">
                    <Back-top></Back-top>
                    <div class="layout-content">
                        <div class="layout-content-main">
                            <template v-if="useTab">
                                <Tabs :value="activeTab" type="card" @on-click="onTabClick" @on-tab-remove="onTabRemove"
                                    closable class="tabs-custom" scrollable
                                    style="background-color: #fff; padding: 5px 2px;">
                                    <TabPane v-for="tab in tabs" :key="tab.path" :label="tab.title" :name="tab.path"
                                        :closable="tab.path !== '/'" />
                                </Tabs>
                                <keep-alive>
                                    <router-view :key="$route.fullPath" />
                                </keep-alive>
                            </template>
                            <template v-else>
                                <router-view></router-view>
                            </template>
                        </div>
                    </div>
                    </Col>
                </Row>
            </div>
        </div>

        <!-- Modal Whats New Tab Mode -->
        <Modal v-model="showWhatsNew" title="Apa yang Baru?" width="800">
            <div style="padding: 20px;">
                <h3>Fitur Tab Mode</h3>
                <br />
                <img :src="require('@/assets/images/tabmode.png')" alt="Tab Mode"
                    style="width: 100%; height: auto; border-radius: 5px;" /> <br />

                <p>
                    Dengan fitur Tab Mode, Anda dapat membuka beberapa halaman dalam satu jendela. Cukup klik tab yang diinginkan untuk beralih antar halaman.
                    Anda juga dapat menutup tab yang sudah tidak diperlukan.

                    <br>
                    <br>
                    Untuk mencoba fitur ini, klik Tab Mode di pojok kanan layar, lalu pilih On.
                </p>
            </div>
            <div slot="footer">
                <Button @click="closeWhatsNew">Tutup</Button>
                <Button type="warning" @click="dontShowWhatsNewAgain">Jangan tampilkan lagi</Button>
            </div>
        </Modal>

    </div>
</template>

<script>
import Login from '@/components/login/Login'
import {HTTP} from '@/components/http-lib'
import { includes } from 'lodash';

let serverIP = localStorage.getItem('serverIP');
let appVersion = localStorage.getItem('appVersion')
let appName = localStorage.getItem('appName')


export default {
    components: { Login },
    data: () => ({
        spanLeft: 4,
        serverIP: serverIP,
        spanRight: 20,
        isLoggedIn: false,
        user: {
            username: '',
            role: ''
        },
        accessToken: localStorage.getItem("access_token"),
        appVersion: appVersion,
        appName: appName,
        iconSize: 15,
        tabs: [
            {
                title: 'Home',
                path: '/'
            }
        ],
        activeTab: '/',
        useTab: false,
        showWhatsNew: false,
    }),
    methods: {
        setIsLoggedIn: function () {
            this.getUserDetail();
            if (!localStorage.getItem('hideWhatsNewTabMode')) {
                this.showWhatsNew = true;
            }
        },
        logout: function () {
            this.isLoggedIn = false
            localStorage.removeItem('access_token');
            localStorage.removeItem('user.username');
            localStorage.removeItem('user.role');
            localStorage.removeItem('user.country');
            this.$forceUpdate()
        },
        getUserDetail: function (isSuccess) {
            HTTP
                .get('auth/user')
                .then(response => {
                    let user = response.data.data;
                    this.user = user
                    localStorage.setItem('user.username', user.username)
                    localStorage.setItem('user.role', user.role)
                    localStorage.setItem('user.subbranchcode', user.subbranchcode)
                    localStorage.setItem('user.country', user.country)
                    this.isLoggedIn = true
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: "Login sudah expired, silahkan login kembali!",
                        duration: 2
                    });
                })

            this.isLoggedIn = isSuccess
        },
        canAccessMenu: function (menu) {
            let canAccess;
            let role = this.user.role

            switch (menu) {
                case "suratjalan":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'PRINT', 'SUPERVISOR-SBY', 'SURAT-JALAN', 'SURAT-JALAN-PIUTANG', 'ADMIN-SUPER'], role);
                    break;
                case "dashboard":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'SUPERVISOR-SBY', 'ADMIN-SUPER'], role);
                    break;
                case "kontra":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'PRINT', 'SUPERVISOR-SBY', 'KONTRA', 'ADMINISTRATOR', 'ADMIN-SUPER'], role);
                    break;

                case "piutang":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'STAFF', 'SUPERVISOR-SBY', 'SURAT-JALAN-PIUTANG', 'ADMIN-SUPER'], role);
                    break;

                case "pembayaran":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'STAFF', 'SUPERVISOR-SBY', 'ADMIN-SUPER'], role);
                    break;

                case "pembayaran-tambah":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'SUPERVISOR-SBY', 'ADMIN-SUPER'], role);
                    break;

                case "pembayaran-history":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'STAFF', 'SUPERVISOR-SBY', 'ADMIN-SUPER'], role);
                    break;

                case "potongan-history":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'STAFF', 'SUPERVISOR-SBY', 'ADMIN-SUPER'], role);
                    break;

                case "pembayaran-delete":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR'], role);
                    break;

                case "pembayaran-history-delete":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR'], role);
                    break;

                case "mutasi-nota-transaksi":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-SUPER'], role);
                    break;

                case "deposit":
                    canAccess = _.includes(['ADMINISTRATOR', 'SUPERVISOR', 'ADMINISTRATOR', 'SUPERVISOR-SBY', 'ADMIN-DEPOSIT', 'ADMIN-SUPER'], role);
                    break;

                case "deposit-add":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'SUPERVISOR-SBY', 'ADMIN-SUPER'], role);
                    break;

                case "pembayaran-pending-list":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'STAFF', 'ADMIN-SUPER'], role);
                    break;

                case "claim":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'STAFF', 'ADMIN-SUPER'], role);
                    break;

                case "giro":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'STAFF', 'ADMIN-SUPER'], role);
                    break;


                case "master":
                    canAccess = _.includes(['ADMINISTRATOR'], role);
                    break;

                case "master.marking-group":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-SUPER'], role);
                    break;

                case "master.marking-top":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN-SUPER'], role);
                    break;

                case "administrator":
                    canAccess = _.includes(['ADMINISTRATOR'], role);
                    break;

                case "pending":
                    canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'STAFF', 'SUPERVISOR-SBY', 'ADMIN-SUPER'], role);
                    break;

                default:
                    canAccess = false;
            }
            return canAccess;
        },
        checkAppJSTag: function () {
            // Get all script tags
            const scripts = document.getElementsByTagName("script");
            localStorage.setItem('X-URL-FE', window.location.href);
            // Loop through and find the one that includes "app."
            for (let script of scripts) {
                if (script.src.includes("app.")) {
                    const parts = script.src.split("/");
                    const filename = parts[parts.length - 1];
                    console.log("Current build JS file:", filename);
                    //break;
                    const match = filename.match(/app\.[^.]+([a-f0-9]{4})\.js$/);
                    if (match) {
                        return match[1].toUpperCase();
                    }
                }
            }
            return "N/A";
        },
        validateVersion: function () {
            HTTP
                .get('version')
                .then(response => {
                    let data = response.data;
                    let serverVersion = data.version.toUpperCase();
                    let localVersion = this.checkAppJSTag().toUpperCase();
        //   console.log("serverVersion == ", serverVersion);
        //   console.log("localVersion == ", localVersion);
        // serverVersion, IGNR means Ignore version checking
        // localVersion, N/A means cannot get local .js version
                    if (serverVersion == "IGNR" || localVersion == "N/A" || serverVersion == "") {
                        return
                    }

                    if (serverVersion != localVersion) {
                        // window.location.reload();
                        return
                    }
                })
                .catch(e => {
                    console.log("validateVersion Error: ", e);
                })
        },
        addTab(route) {
            const pathPrefix = "/payment/paymentPending/list-data/search";
            const existingIndex = this.tabs.findIndex(tab => tab.path.startsWith(pathPrefix));
            if (existingIndex !== -1 && route.path.startsWith(pathPrefix)) {
                this.tabs.splice(existingIndex, 1);
            }

            const exist = this.tabs.find(tab => tab.path === route.path)

            if (route.name !== 'paymentPendingAdd') { // exclude payment mutasi on tabspane
                if (!exist) {
                    this.tabs.push({
                        title: route.meta.title,
                        path: route.path,
                    })
                }
            }

            this.activeTab = route.path
        },
        onTabClick(name) {
            if (this.$route.path !== name) {
                this.$router.push(name)
            }
        },
        onTabRemove(name) {
            console.log({name});

            const idx = this.tabs.findIndex(tab => tab.path === name)
            if (idx > -1) {
                this.tabs.splice(idx, 1)
                // Jika tab yang dihapus adalah tab aktif, pindah ke tab sebelumnya/berikutnya
                if (this.activeTab === name) {
                    const nextTab = this.tabs[idx] || this.tabs[idx - 1]
                    if (nextTab) {
                        this.$router.push(nextTab.path)
                    }
                }
            }

        },
        onTabChange(value) {
            this.useTab = value;
            localStorage.setItem('useTab', value);
            this.tabs = [{
                    title: 'Home',
                    path: '/'
                }]
                this.activeTab = '/';
            if (value) {
                this.addTab(this.$route);
            }
            // location.reload()
        },
        closeWhatsNew() {
            this.showWhatsNew = false;
        },
        dontShowWhatsNewAgain() {
            localStorage.setItem('hideWhatsNewTabMode', 'true');
            this.showWhatsNew = false;
        },
    },
    computed: {
        iconSize() {
            return 15;
        }
    },
    mounted() {
        this.validateVersion()
    },
    created() {
        if (this.accessToken != undefined) {
            HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + this.accessToken;
            this.setIsLoggedIn();
        }
        this.useTab = localStorage.getItem('useTab') === 'true' || false;
        if (this.useTab) {
            this.addTab(this.$route)
        }
    },
    computed: {
        isDev: function () {
            return (_.includes(serverIP, "localhost") || _.includes(serverIP, "127.0.0.1") || _.includes(serverIP, "8.214.64.22:8082") || _.includes(serverIP, "dev-api.blueray-cargo.com"));
        }
    },
    watch: {
        '$route'(to, from) {
            this.addTab(to)
        }
    },
}

</script>



// WEBPACK FOOTER //
// App.vue?75b986fe